import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { DEFAULT_LOCIZE_NAMESPACE } from '../../constants';
import styles from './Input.module.css';

const Input = forwardRef(
  ({ locizeNamespace, placeholder, className, ...props }, ref) => {
    const { t, ready } = useTranslation(locizeNamespace, {
      useSuspense: false,
    });

    return (
      <input
        ref={ref}
        className={classNames(styles.input, className)}
        placeholder={placeholder && ready ? t(placeholder) : ''}
        {...props}
      />
    );
  }
);

Input.propTypes = {
  placeholder: PropTypes.string,
  locizeNamespace: PropTypes.string,
};

Input.defaultProps = {
  placeholder: '',
  locizeNamespace: DEFAULT_LOCIZE_NAMESPACE,
};

export default Input;
